"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
var Utilities_1 = require("../../Utilities");
exports.getStyles = Utilities_1.memoizeFunction(function (theme, customStyles) {
    if (theme === void 0) { theme = Styling_1.getTheme(); }
    if (customStyles === void 0) { customStyles = undefined; }
    var iconStyles = {
        root: Styling_1.mergeStyles([
            theme.fonts.icon,
            {
                display: 'inline-block'
            }
        ]),
        imageContainer: Styling_1.mergeStyles({
            overflow: 'hidden'
        })
    };
    return Styling_1.mergeStyleSets(iconStyles, customStyles);
});
//# sourceMappingURL=Icon.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Icon/Icon.styles.js
// module id = 328
// module chunks = 0